import Rails from './Rails';

export default Rails;
